import { Button } from "@itandi/itandi-bb-ui/Button";
import type { DealConstructionContext } from "~/models/DealConstruction";

type Props = {
	constructionContext: DealConstructionContext;
	dealEstimationDraftHeader: DealConstructionContext | null;
	dealEstimationHistoryContext: DealConstructionContext | null;
	handleClickEstimationHistoryPreview: (() => void) | null;
	handleClickEstimationPreview: (() => void) | null;
	ownManagement: boolean;
};

export function ConstructionDownloadButtons({
	constructionContext,
	dealEstimationHistoryContext,
	dealEstimationDraftHeader,
	handleClickEstimationPreview,
	handleClickEstimationHistoryPreview,
	ownManagement
}: Props) {
	const hasConstructions = !!constructionContext.dealConstructions.length;
	const hasDraftConstructions =
		!!dealEstimationDraftHeader?.dealConstructions.length;
	const hasHistoryConstructions =
		!!dealEstimationHistoryContext?.dealConstructions.length;
	const showEstimationHistory = dealEstimationHistoryContext && !ownManagement;

	const handleClickEstimationPreviewDisabled = (() => {
		if (ownManagement && dealEstimationDraftHeader) {
			return !hasDraftConstructions && !hasConstructions;
		}
		return !hasConstructions;
	})();

	return (
		<>
			{handleClickEstimationPreview ? (
				<Button
					disabled={handleClickEstimationPreviewDisabled}
					onClick={handleClickEstimationPreview}
					variant="secondary"
				>
					{showEstimationHistory
						? "申請前見積書ダウンロード"
						: "見積書ダウンロード"}
				</Button>
			) : null}
			{handleClickEstimationHistoryPreview && !ownManagement ? (
				<Button
					disabled={!hasDraftConstructions && !hasHistoryConstructions}
					onClick={handleClickEstimationHistoryPreview}
					variant="secondary"
				>
					{dealEstimationHistoryContext
						? "申請後見積書ダウンロード"
						: "見積書ダウンロード"}
				</Button>
			) : null}
		</>
	);
}
